import React from "react";
import LogoImage from "../../Assets/Images/logo.png";

const Logo = () => (
  <img
    src={LogoImage}
    width="90%"
    style={{ marginTop: "0.5rem", marginLeft: "0.7rem" }}
    alt="Logo"
  />
);
export default Logo;
